//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import type { Draft, PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

const PREFIX = 'nav'

// Define a type for the slice state
export interface NavState {
  url: string | undefined
}

// Define the initial state using that type
export const initialNavState: NavState = {
  url: undefined,
}

export const navSlice = createSlice({
  name: PREFIX,
  initialState: initialNavState,
  reducers: {
    resetURL: (navState: Draft<NavState>, _action: PayloadAction<undefined>) => {
      navState.url = undefined
    },
    navigateTo: (navState: Draft<NavState>, action: PayloadAction<{ url: string | undefined }>) => {
      navState.url = action.payload.url
    },
  },
})

export const navActions = { ...navSlice.actions }

export default navSlice
